/**
 * FLOATING_VIDEO_CONFIG
 *
 * Per-page configuration for the FloatingVideoPlayer component.
 * Each key is a page slug that matches the `pageKey` prop passed to
 * <FloatingVideoPlayer pageKey="..." />.
 *
 * Fields per entry:
 *   title           — text shown in the floating window header
 *   videoUrl        — YouTube URL (e.g. https://youtu.be/ID) or a direct .mp4 URL
 *   thumbnailImage  — optional import/path shown as preview before the video plays;
 *                     set to null to show the plain background colour instead
 *   defaultPosition — { xRatio, yRatio } desktop default (> 1024px)  — fraction of viewport (0–1)
 *   tabletPosition  — { xRatio, yRatio } tablet override (769px – 1024px); falls back to defaultPosition
 *   mobilePosition  — { xRatio, yRatio } mobile override (≤ 768px);  falls back to defaultPosition
 *   defaultSize     — { width, height } in pixels (also the minimum size)
 *
 * xRatio/yRatio examples:
 *   xRatio: 0.6  → window starts at 60% of screen width from the left
 *   yRatio: 0.45 → window starts at 45% of screen height from the top
 *
 * To add a new page: add a new key here — no other file needs to change.
 */
import CustomerFloatingimg from "../../assets/img/apponboarding/customer_floating.png";


export const FLOATING_VIDEO_CONFIG = {
  "add-customer": {
    title: "How to Add a Customer",
    videoUrl: "https://youtu.be/EcdJFUAePEw",
    thumbnailImage: CustomerFloatingimg,
    defaultPosition: { xRatio: 0.82, yRatio: 0.7 },
    tabletPosition: { xRatio: 0.04, yRatio: 0.12 },
    mobilePosition: { xRatio: 0.03, yRatio: 0.08 },
    defaultSize: { width: 400, height: 280 },
  },

  // Future pages — uncomment and fill in as needed:
  // "create-job": {
  //   title: "How to Create a Job",
  //   videoUrl: "https://www.youtube.com/watch?v=EXAMPLE_ID",
  //   thumbnailImage: null,
  //   defaultPosition: { xRatio: 0.6, yRatio: 0.2 },
  //   defaultSize: { width: 400, height: 280 },
  // },
  // "schedule-job": {
  //   title: "How to Schedule a Job",
  //   videoUrl: "https://www.youtube.com/watch?v=EXAMPLE_ID",
  //   thumbnailImage: null,
  //   defaultPosition: { xRatio: 0.6, yRatio: 0.2 },
  //   defaultSize: { width: 400, height: 280 },
  // },
};